var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMessage = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 127,
    viewBox: "0 0 133 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4561_6677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.8452 126.999C92.8968 126.999 119.69 100.159 119.69 67.0486C119.69 33.9386 92.8968 7.09766 59.8452 7.09766C26.7936 7.09766 0 33.9386 0 67.0486C0 100.159 26.7936 126.999 59.8452 126.999Z",
    fill: "#116EEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.934 39.4717H23.938V115.01C35.6168 123.78 50.0924 127.972 64.6409 126.797C79.1894 125.622 92.8078 119.162 102.934 108.631V39.4717Z",
    fill: "#D9EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.934 45.4668H23.938V46.6658H102.934V45.4668Z",
    fill: "#C3DAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.934 52.6602H23.938V53.8592H102.934V52.6602Z",
    fill: "#C3DAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.934 59.8545H23.938V61.0535H102.934V59.8545Z",
    fill: "#C3DAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.934 67.0488H23.938V68.2478H102.934V67.0488Z",
    fill: "#C3DAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.934 74.2432H23.938V75.4422H102.934V74.2432Z",
    fill: "#C3DAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.934 81.4375H23.938V82.6365H102.934V81.4375Z",
    fill: "#C3DAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.934 88.6309H23.938V89.8299H102.934V88.6309Z",
    fill: "#C3DAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.934 95.8252H23.938V97.0242H102.934V95.8252Z",
    fill: "#C3DAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.934 103.02H23.938V104.219H102.934V103.02Z",
    fill: "#C3DAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.354 110.214H23.938V111.413H100.097C100.54 111.029 100.935 110.622 101.354 110.214Z",
    fill: "#C3DAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2931 117.407H27.397C28.0194 117.827 28.6657 118.223 29.312 118.606H90.3541C91.0244 118.223 91.6707 117.827 92.2931 117.407Z",
    fill: "#C3DAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9536 109.854C28.3539 120.066 42.1141 126.128 56.6561 126.905C71.198 127.682 85.5238 123.12 96.9493 114.075V46.666H17.9536V109.854Z",
    fill: "#F6FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9493 52.6602H17.9536V53.8592H96.9493V52.6602Z",
    fill: "#C3DAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9493 59.8545H17.9536V61.0535H96.9493V59.8545Z",
    fill: "#C3DAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9493 67.0488H17.9536V68.2478H96.9493V67.0488Z",
    fill: "#C3DAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9493 74.2432H17.9536V75.4422H96.9493V74.2432Z",
    fill: "#C3DAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9493 81.4375H17.9536V82.6365H96.9493V81.4375Z",
    fill: "#C3DAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9493 88.6309H17.9536V89.8299H96.9493V88.6309Z",
    fill: "#C3DAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9493 95.8252H17.9536V97.0242H96.9493V95.8252Z",
    fill: "#C3DAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9493 103.02H17.9536V104.219H96.9493V103.02Z",
    fill: "#C3DAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9493 110.214H17.9536V111.413H96.9493V110.214Z",
    fill: "#C3DAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2811 117.407H27.397C28.0313 117.815 28.6657 118.223 29.312 118.606H90.3541C90.9645 118.223 91.6468 117.827 92.2811 117.407Z",
    fill: "#C3DAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6017 124.602H43.0884C44.6563 125.069 46.2482 125.477 47.876 125.801H71.7303C73.382 125.477 74.9979 125.069 76.6017 124.602Z",
    fill: "#C3DAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.164 5.9806L65.7539 61.4883L71.6529 67.3977L127.063 11.89L121.164 5.9806Z",
    fill: "#FDC000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.341 4.79905L121.165 5.97754L127.064 11.8869L128.24 10.7085L122.341 4.79905Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.699 2.42893L123.523 3.60742L129.422 9.51682L130.598 8.33834L124.699 2.42893Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.527 3.61155L122.35 4.79004L128.249 10.6994L129.426 9.52095L123.527 3.61155Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.884 1.24241L124.708 2.4209L130.607 8.3303L131.783 7.15181L125.884 1.24241Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.779 7.19378C132.172 6.80486 132.485 6.34221 132.699 5.83226C132.914 5.3223 133.026 4.77502 133.029 4.22167C133.033 3.66831 132.927 3.11972 132.719 2.60721C132.511 2.09469 132.204 1.6283 131.815 1.23466C131.427 0.841015 130.965 0.527829 130.456 0.312984C129.947 0.0981377 129.401 -0.0141612 128.848 -0.0175014C128.296 -0.0208415 127.748 0.0848425 127.237 0.293517C126.725 0.502191 126.26 0.809768 125.867 1.19869L131.779 7.19378Z",
    fill: "#C07C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7577 61.4849L57.8462 75.2856L71.6465 67.3841V65.4057H69.6836V63.4393H67.7087V61.4609L65.7577 61.4849Z",
    fill: "#C69C6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.796 71.3415C61.4446 70.9928 61.0066 70.7444 60.5273 70.6221L57.8462 75.2862L62.5141 72.6124C62.3925 72.1321 62.1445 71.6931 61.796 71.3415Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4561_6677"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 133,
    height: 127,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMessage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Message.06af49874af1eb2bd467693b8f392e06.svg";